
import React from 'react';

const IconButton = ({icon, onClick}) => {
    return (
        <div className="flex align-middle items-center justify-center  p-1 rounded-full hover:bg-indigo-700">
            <button onClick={onClick}>
                <img 
                    src={icon} 
                    alt="icon" 
                    className="h-4 w-4"
                />
            </button>
        </div>
    );
};

export default IconButton;